/* eslint-disable */
import React from "react";
import back_asset from "../../assets/01_Home/Icon_Left.svg";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface DestacadosComponentProps {
  categories: any;
}

const DestacadosComponent: React.FC<DestacadosComponentProps> = ({
  categories,
}) => {
  return (
    <>
      <div className="destacados-normal-news">
        <div className="title">Destacados</div>
        <div className="categories row">
          {categories?.map((item: any) => (
            <div
              key={item?.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
            >
              <Link to={`/noticias/${item?.category_id}/${item?.slug}`} className="category">
                <img 
                  src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
                  alt={item?.title || "Imagen destacada"} 
                />
                <div className="subtitle">{item?.category}</div>
                <div className="description">{item?.title}</div>
                <Link className="readMore" to={`/noticias/${item?.category_id}/${item?.slug}`}>Leer más</Link>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DestacadosComponent;